import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faArrowDown } from '@fortawesome/free-solid-svg-icons';

import sharedStyles from '../../styles/shared.css';
import styles from './styles.css';

const { compare, shortenLargeNumber, convertToTimeDuration } = require('../../../lib/bputils').default;

class StatNumber extends React.Component {
  static propTypes = {
    value: PropTypes.number,
    compareTo: PropTypes.number,
    showDifference: PropTypes.bool,
    statType: PropTypes.string.isRequired,
  }

  static defaultProps = {
    value: null,
    compareTo: null,
    showDifference: false,
  }

  getCss = (value) => {
    let trendIcon = '';
    let colorCssClass = sharedStyles.neutral;

    if (value > 0) {
      trendIcon = faArrowUp;
      colorCssClass = sharedStyles.positive;
    }
    if (value < 0) {
      trendIcon = faArrowDown;
      colorCssClass = sharedStyles.negative;
    }
    return { trendIcon, colorCssClass };
  }

  formatStatNumber = (statNumber) => {
    if (!statNumber && statNumber !== 0) {
      return 'N/A';
    }

    const { statType } = this.props;
    let displayValue = '';
    if (statType === 'avg_dwell_time') {
      displayValue = convertToTimeDuration(statNumber);
    } else {
      displayValue = shortenLargeNumber(statNumber);
    }

    return displayValue;
  }

  render() {
    const { value, compareTo, showDifference } = this.props;
    let trendIcon = '';
    let colorCssClass = '';
    let displayValue = value;

    if (showDifference) {
      displayValue = compare(value, compareTo);
      ({ trendIcon, colorCssClass } = this.getCss(displayValue));
    }

    return (
      <span className={`${colorCssClass} ${styles.compareContainer}`}>
        {this.formatStatNumber(displayValue)}
        { !!trendIcon && <FontAwesomeIcon icon={trendIcon} />}
        {/* <FontAwesomeIcon icon={faSortDown} /> */}
      </span>
    );
  }
}

export default StatNumber;
